// NO StrictMode: in React 18 dev it double-invokes mount effects, which would dial the
// call twice and run the ported VideoState teardown mid-setup. The core was written for
// single-mount semantics and must keep them.
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/caller-flow.css'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
